<template>
    <v-app>
        <component :is="layout">
        </component>
        
        <v-overlay :value="overlay">
            <v-progress-circular v-if="loading"
                indeterminate
                size="64"
            ></v-progress-circular>
            <v-dialog persistent v-model="authenticate" max-width="50%">
                <v-card>
                    <v-card-title class="text-h3 redirect-modal">
                        {{ $t("unauthenticated") }}
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn rounded dark color="#1B475D" x-large class="feuchter-button" @click="authenticateRedirect">{{ $t("unauthenticated_button") }}</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-overlay>
    </v-app>
</template>

<style lang="scss">
html {
    overflow: hidden !important;
}

.redirect-modal {
    white-space: pre-wrap;
    text-align: center;
    color: $font-color !important;
}

</style>
<script>
import crypto from 'crypto-js';
import moment from 'moment';
export default {
    data() {
        return {
            overlay: false,
            loading: false,
            authenticate: false,
            defaultLayout: "default"
        }
    },
    created() {
        window.addEventListener('reloadWindowLocation', function () {
            window.location.reload();
        });

        this.$root.$on('unauthenticated', () => {
            this.checkTokenValidityAndRefresh(true, true);
        });

        let urlParams = new URLSearchParams(window.location.search);
        if(urlParams.has('code')) {
            this.overlay = true;
            this.loading = true;
            this.$store.dispatch({
                type: 'moduleAuth/loginGetOAuthToken',
                code: urlParams.get('code')
            }).then(() => {
                window.history.replaceState(null,'',window.location.pathname);
                this.overlay = false;
                this.loading = false;
            }).catch((error) => {
                this.apiErrorMessageHandler(error);
                this.overlay = false;
                this.loading = false;
            });
        } else if(this.$route.query.authToken !== undefined) {
            this.$store.commit({
                type: 'moduleAuth/setAuthToken',
                authToken: this.$route.query.authToken
            });
        } else if(this.$store.getters['moduleAuth/getAuthToken'] === null || this.$store.getters['moduleAuth/getAuthToken'] === undefined) {
            this.overlay = true;
            this.authenticate = true;
        } else {
            this.checkTokenValidityAndRefresh();
        }

        setInterval(this.checkTokenValidityAndRefresh, 600000); //alle 10 min die expiry des Authtoken prüfen
    },
    methods: {
        authenticateRedirect() {
            let verifier = [...Array(128)].map(() => Math.random().toString(36)[2]).join('');
            let codeChallenge = crypto.SHA256(verifier);
            codeChallenge = codeChallenge.toString(crypto.enc.Base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
            this.$store.commit({
                type: 'moduleAuth/setVerifier',
                verifier: verifier
            });

            let url = process.env.VUE_APP_API_HOST + '/oauth/authorize?redirect_uri=' + process.env.VUE_APP_API_REDIRECT_URI + '&client_id=' + process.env.VUE_APP_API_CLIENT_ID
                + '&response_type=code&state=&code_challenge=' + codeChallenge + '&code_challenge_method=S256';
            window.location.href = url;
        },
        checkTokenValidityAndRefresh(forced = false, reload = false) {
            let expires = moment(this.$store.getters['moduleAuth/getExpiresAt']);
            let now = moment(moment.now()).add(20, 'minutes');
            if(now.isAfter(expires) || forced){
                this.overlay = true;
                this.loading = true;
                this.$store.dispatch({
                    type: 'moduleAuth/refreshOAuthToken'
                }).then(() => {
                    if(reload){
                        window.location.reload();
                    }
                    this.overlay = false;
                    this.loading = false;
                }).catch(() => {
                    this.authenticate = true;
                    this.loading = false;
                });
            }
        }
    },
    computed: {
        layout() {
            return (this.$route.meta.layout || this.defaultLayout) + '-layout';
        }
    }
}
</script>